import {Directive, HostListener} from '@angular/core'
import {AppAsideService} from '@app/features/page/app-aside/app-aside.service'

/**
 * Allows the aside to be toggled via click.
 */
@Directive({
  selector: '[appAsideMenuToggler]',
  standalone: false,
})
export class AsideToggleDirective {
  constructor(private appAsideService: AppAsideService) {}

  @HostListener('click', ['$event'])
  toggleOpen($event: any) {
    $event.preventDefault()
    this.appAsideService.toggleVisible()
  }
}
